// src/hooks/hotelMealPlans/useRestoreAllHotelMealPlans.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllHotelMealPlans as restoreAllHotelMealPlansAPI } from "../../api/apiHotelMealPlans";
import parseError from "../../utils/parseError";

const useRestoreAllHotelMealPlans = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAll, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllHotelMealPlansAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel meal plans restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlans"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore selected hotel meal plans");
        },
    });

    return { restoreAllHotelMealPlans: restoreAll, isRestoreAll };
};

export default useRestoreAllHotelMealPlans;
